import React from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import Team from '../components/Team'

function About() {
  return (
    <div>
      <Navbar />
      <Team />
      <Footer />
    </div>
  )
}

export default About
